"use strict";

exports.__esModule = true;
exports.default = genericInFunc;

function genericInFunc(obj, rec) {
  return 0;
}

genericInFunc._r = [2, ["C", "R"]];
genericInFunc.displayName = "genericInFunc";